module.exports = __webpack_public_path__ + "img/about4.765f817.jpg";